export default {"src":"/_next/static/media/facebookIcon.b131e779.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};